// extracted by mini-css-extract-plugin
export var chip = "_4g-9";
export var chipLabel = "_4g-a";
export var close = "_4g-7";
export var closeIcon = "_4g-8";
export var error = "_4g-6";
export var infoTooltip = "_4g-2";
export var innerContainer = "_4g-1";
export var input = "_4g-b";
export var medium = "_4g-5";
export var outerContainer = "_4g-0";
export var small = "_4g-4";
export var xSmall = "_4g-3";